import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'

const mutation = `
  mutation DraftOrderInvoiceSend($id: ID!, $email: EmailInput) {
    draftOrderInvoiceSend(id: $id, email: $email) {
      draftOrder {
        id
      }
    }
  }
`

const doSendInvoice = (integrationId, draftOrderId, emailData) => dispatch => {
  const variables = {
    id: draftOrderId,
    email: {
      to: emailData.to,
    },
  }

  return dispatch(
    doGraphqlRequest(types.INVOICE_SEND_REQUEST, mutation, variables, {
      graphqlFunc: graphql(integrationId),
      moduleOptions: {
        toasts: {
          enabled: true,
          started: {
            enabled: false,
          },
          success: {
            enabled: true,
            content: 'Invoice sent',
          },
          failed: {
            enabled: true,
            content: 'Invoice sending failed',
          },
        },
      },
    })
  )
}

export default doSendInvoice
